export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'a3e86ff3-24cf-4051-bf6d-8c34615f55de';
export const MODAL_CLOSE_SEC = 2.5;
